import { LanguageDto } from '../../models/language/LanguageDto';
import { RootState } from '../store';

// Selectors
export const selectLanguages = (state: RootState): LanguageDto[] =>
    [
        { name: 'English', id: 'en' },
        { name: 'suomi', id: 'fi' },
    ].sort((a, b) => a.name.localeCompare(b.name));
